import styled, { css } from 'styled-components';
import Grid from '../Grid';
export const Container = styled(Grid)`
  display: grid;
  ${({
  trigger,
  collapsedIn
}) => trigger && css`
      > *:nth-child(n + ${collapsedIn}) {
        display: none;
        overflow: hidden;
        max-height: 0;
      }
    `};
`;